
import { defineComponent, onMounted, reactive, toRefs,getCurrentInstance } from 'vue'
import MdEditor from 'md-editor-v3';
import 'md-editor-v3/lib/style.css';
import markExtension from '../common/markExtension.vue';
MdEditor.config({
    editorConfig: {
      // 语言
      languageUserDefined: {
        'zh-CN': {
          toolbarTips: {
            bold: '加粗\nCtrl+B',
            underline: '下划线\nCtrl+U',
            italic: '斜体\nCtrl+I',
            strikeThrough: '删除线\nCTRL+SHIFT+S',
            title: '标题\nCTRL+1-6',
            sub: '下标\nCTRL+↓',
            sup: '上标\nCTRL+↑',
            quote: '引用\nCTRL+Q',
            unorderedList: '无序列表\nCTRL+SHIFT+U',
            orderedList: '有序列表\nCTRL+O',
            codeRow: '行内代码\nCTRL+ALT+C',
            code: '块级代码\nCTRL+SHIFT+C',
            link: '链接\nCTRL+L	',
            image: '图片',
            table: '表格',
            mermaid: 'mermaid图',
            katex: 'katex公式',
            revoke: '后退\nCTRL+Z',
            next: '前进\nCTRL+SHIFT+Z',
            save: '保存\nCTRL+S',
            prettier: '美化',
            pageFullscreen: '浏览器全屏',
            fullscreen: '屏幕全屏',
            preview: '预览',
            // htmlPreview: 'html代码预览',
            catalog: '目录',
            github: '源码地址'
          },
          titleItem: {
            h1: '一级标题',
            h2: '二级标题',
            h3: '三级标题',
            h4: '四级标题',
            h5: '五级标题',
            h6: '六级标题'
          },
          imgTitleItem: {
            link: '添加链接',
            upload: '上传图片',
            clip2upload: '裁剪上传'
          },
          linkModalTips: {
            title: '添加',
            descLable: '链接描述：',
            descLablePlaceHolder: '请输入描述...',
            urlLable: '链接地址：',
            UrlLablePlaceHolder: '请输入链接...',
            buttonOK: '确定'
          },
          clipModalTips: {
            title: '裁剪图片上传',
            buttonUpload: '上传'
          },
          copyCode: {
            text: '复制代码',
            successTips: '已复制！',
            failTips: '复制失败！'
          },
          mermaid: {
            flow: '流程图',
            sequence: '时序图',
            gantt: '甘特图',
            class: '类图',
            state: '状态图',
            pie: '饼图',
            relationship: '关系图',
            journey: '旅程图'
          },
          katex: {
            inline: '行内公式',
            block: '块级公式'
          },
          footer: {
            markdownTotal: '字数',
            scrollAuto: '同步滚动'
          }
        },
      },
      renderDelay: 0
    },
    markedRenderer(renderer) {
      // 链接判断，如果是a跳新页签，如果是视频用video播放器
      renderer.link = (href, title, text) => {
          console.log(href,'href')
          console.log(title,'title')
          console.log( text,'text')
          // 判断是视频还是链接
          if(text.indexOf('视频')>-1 ||(href&&(href.indexOf('.mp4')>-1||href.indexOf('video')>-1))){
          return `<video style="width: 350px"  autoplay loop preload="none" name="media"><source src="${href}" type="video/mp4"></video>`
          }else{
            return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
          }
        
      };
      return renderer;
    }
});
export default defineComponent({
    components:{MdEditor,markExtension},
    setup(prop,context) {
        const {proxy,appContext}=getCurrentInstance() as any
        const state=reactive({
            footers:['markdownTotal','=', 0,'scrollSwitch'],
            toolbars:['bold','underline','italic','strikeThrough','-','title','sub','sup','quote','unorderedList','orderedList','-','codeRow','code','link','image','table','mermaid','katex',0,1,2,'-','revoke','next','save','=','prettier','pageFullscreen','fullscreen','preview','catalog','github'],
            markValue:"<p><video style=\"width: 350px\" controls=\"\"  name=\"media\"><source src=\"https://awscdn.awspaas.com/data/static/video/noviceGuide.mp4\" type=\"video/mp4\"></video></p>\n<p><span class=\"figure\"><img src=\"https://img0.baidu.com/it/u=32980539,2719126699&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1660150800&t=6f2e1b65b9fd97ced953c10c154c1839\" title=\"\" alt=\"\" zoom><span class=\"figcaption\"></span></span><span class=\"figure\"><img src=\"https://img0.baidu.com/it/u=32980539,2719126699&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1660150800&t=6f2e1b65b9fd97ced953c10c154c1839\" title=\"\" alt=\"\" zoom><span class=\"figcaption\"></span></span></p>\n<h1 id=\"这是1级标题\"><a href=\"#这是1级标题\">这是1级标题</a></h1><table>\n<thead>\n<tr>\n<th>col</th>\n<th>col</th>\n</tr>\n</thead>\n<tbody><tr>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n</tr>\n</tbody></table>\n<h2 id=\"这是二级\"><a href=\"#这是二级\">这是二级</a></h2><ol>\n<li>别动</li><li>别跑</li><li>别说话</li><li>欧吼</li></ol>\n<h3 id=\"这是三级\"><a href=\"#这是三级\">这是三级</a></h3><table>\n<thead>\n<tr>\n<th>col</th>\n<th>col</th>\n<th>col</th>\n</tr>\n</thead>\n<tbody><tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n</tbody></table>\n<h4 id=\"这是四级\"><a href=\"#这是四级\">这是四级</a></h4><table>\n<thead>\n<tr>\n<th>col</th>\n<th>col</th>\n<th>col</th>\n</tr>\n</thead>\n<tbody><tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n</tbody></table>\n<table>\n<thead>\n<tr>\n<th>col</th>\n<th>col</th>\n<th>col</th>\n</tr>\n</thead>\n<tbody><tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n<tr>\n<td>content</td>\n<td>content</td>\n<td>content</td>\n</tr>\n</tbody></table>\n<h5 id=\"这是最后了\"><a href=\"#这是最后了\">这是最后了</a></h5><pre><code class=\"language-language\"><span class=\"code-block\">    嘤嘤嘤</span>\n</code></pre>\n"
        })
        const methods=reactive({
            // 图片上传
            onUploadImg:(files: FileList,callback: (urls: string[]) => void)=>{
                // console.log(files,'files')
                callback(['https://img0.baidu.com/it/u=32980539,2719126699&fm=253&app=120&size=w931&n=0&f=JPEG&fmt=auto?sec=1660150800&t=6f2e1b65b9fd97ced953c10c154c1839'])
            },
            // 代码保存
            codeSave:(v:string):void=>{
                console.log(JSON.stringify(v))
            },
            // 保存html
            saveHtml:(h:String)=>{
                console.log(JSON.stringify(h),111)
            },
            // 获取日志
            onGetCatalog:(list:[])=>{
                console.log(list,'list')
            },
        })
        onMounted(()=>{
           // 给获取的图片父级添加样式
            let figureList:any=document.getElementsByClassName('figure')
            for(let i=0;i<figureList.length;i++){
                if(figureList[i]&&figureList[i].parentNode){
                    let parentDom:any=figureList[i].parentNode
                    parentDom.style='display:flex;justify-content:center'
                }
                // figureList[i]?.parentNode?.style='handleMdClass'
            }
            // 给获取的视频父级添加样式
            let videoList:any=document.getElementsByTagName('video')
            for(let i=0;i<videoList.length;i++){
                if(videoList[i]&&videoList[i].parentNode){
                    let parentDom:any=videoList[i].parentNode
                    parentDom.style='display:flex;justify-content:center'
                }
            }
        })
        return {
            ...toRefs(state),
            ...toRefs(methods)
        }
    }
})
